import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-legal-terms',
  templateUrl: './legal-terms.component.html',
  styleUrls: ['./legal-terms.component.scss']
})
export class LegalTermsComponent implements OnInit {

  public clientId;
  private languageId;

  constructor(
    private activatedRoute: ActivatedRoute,
    private utils: UtilsService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.clientId = this.activatedRoute.snapshot.queryParamMap.get('clientId') ? Number(this.activatedRoute.snapshot.queryParamMap.get('clientId')) : 1
    this.languageId = this.activatedRoute.snapshot.queryParamMap.get('languageId') ? Number(this.activatedRoute.snapshot.queryParamMap.get('languageId')) : 1

    this.translateService.setDefaultLang(this.utils.getLanguageFromLanguageId(this.languageId))
    this.translateService.use(this.utils.getLanguageFromLanguageId(this.languageId))
    document.documentElement.lang = this.utils.getLanguageFromLanguageId(this.languageId).split('-')[0];
  }

}
